import { List, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { charactersStore } from "stores";
import { RouterPathEnum } from "shared/enums/commonEnums";

interface LevelsProps {
  dynamic?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Levels = ({ dynamic, setOpen }: LevelsProps) => {
  const navigate = useNavigate();
  const levels = [1, 2, 3, 4, 5, 6];

  const onClick = (level: number) => {
    const char = charactersStore.selectedCharacter;
    if (!char) return;

    charactersStore.currentLevel = "level" + level;

    // передаём userId сразу
    //sceneStore.setUser(String(char.userId));

    // загружаем данные, ошибки не мешают отрисовке сцены
    charactersStore
      .loadCharacterData(charactersStore.currentLevel)
      .catch((e) => console.warn("Ошибка загрузки данных персонажа:", e));

    if (setOpen) setOpen(false);

    // ⚡ важно — не сбрасывать selectedCharacter!
    navigate(RouterPathEnum.SceneMuscle);
  };

  if (!charactersStore.selectedCharacter) return null;

  return (
    <div>
      Уровни:
      <List>
        {levels.map((level) => (
          <ListItemButton key={level} onClick={() => onClick(level)}>
            <ListItemText primary={level} />
          </ListItemButton>
        ))}
      </List>
    </div>
  );
};

export default observer(Levels);
